<script lang="ts">
export type InflowSourceDefinitionForm = {
  inflowSourceName: string
  useShortenedURL: boolean
  matchAssigendStaffs: string[]
}

export default {}
</script>

<script setup lang="ts">
import { computed, ref } from 'vue'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import DolphinCheckbox from '@/components/atoms/DolphinCheckbox.vue'
import type { SettingPageLineActivationInflowSourceFormQueryFragment } from './SettingPageLineActivationInflowSourceForm.generated'
import SettingPageLineActivationInflowSourceFormAssignedStaff from './SettingPageLineActivationInflowSourceFormAssignedStaff.vue'

const props = defineProps<{
  fragment: SettingPageLineActivationInflowSourceFormQueryFragment
  form: InflowSourceDefinitionForm
}>()

const emit = defineEmits<{
  (event: 'save', data: InflowSourceDefinitionForm): void
}>()

const form = ref(props.form)

const staffs = computed(() => props.fragment.staffsByPlanner ?? [])

const save = () => {
  emit('save', { ...form.value })
}
</script>

<template>
  <section>
    <div :class="$style.form">
      <p :class="$style.label">追加経路名</p>
      <DolphinTextInput
        :class="$style.textInput"
        v-model="form.inflowSourceName"
      />
      <p :class="$style.label">URLを短縮する</p>
      <DolphinCheckbox v-model="form.useShortenedURL" />
      <p :class="[$style.label, $style.assignedStaffLabel]">
        割り当てられる担当者
      </p>
      <SettingPageLineActivationInflowSourceFormAssignedStaff
        v-model="form.matchAssigendStaffs"
        :all-staffs="staffs"
      />
    </div>
    <div :class="$style.submit">
      <FlatButton
        :class="$style.submit"
        @click="save"
        :disabled="form.inflowSourceName.length == 0"
      >
        この内容で保存する
      </FlatButton>
    </div>
  </section>
</template>

<style module lang="scss">
.form {
  display: grid;
  grid-template-columns: 1fr 4fr;
  row-gap: 32px;
  justify-content: space-between;
  align-items: center;
}

.label {
  color: $color-text-and-object-high-emphasis;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}

.textInput {
  width: 100%;
}

.assignedStaffLabel {
  align-self: flex-start;
  padding: 8px 0;
}

.submit {
  display: flex;
  margin-top: 16px;
  justify-content: center;
}
</style>
